@if ({
  hasFooter: uiService.getFooterStatus() | async
  }; as _) {
  @if (_.hasFooter) {
    <footer class="text-xs">
      @if (legals) {
        <a [href]="legals" data-test="legals">{{'footer.tou' | translate}}</a>
      }
      @if (privacy) {
        <a [href]="privacy" data-test="privacy">{{'footer.privacy' | translate}}</a>
      }
      @if (notCookies) {
        <a [routerLink]="['/cookies']" [queryParams]="{preferences: true}" data-test="cookies">{{'footer.cookies' | translate}}</a>
      }
    </footer>
  }
}

